<template>
    <modal @close="$emit('close')" :max_width="400" :width="isMobile?320:400" :click_outside="true" class="relative">

        <div v-if="Object.values(error).length === 0" class="p-8 relative">
            <img @click="close" class="cursor-pointer absolute pin-r pin-t m-4" src="@/assets/SVG/cross-partners.svg" alt="">
          <p class="font-bold text-center mt-8">
              Поздравляем!
          </p>
          <p class="mt-5 text-center mb-5">
              Вы стали участником команды <span class="text-brand-light" style="word-break: break-all"> {{team_name}} </span>
          </p>
        </div>
        <div v-else-if="'token' in error" class="p-8 relative">
          <img @click="close" class="cursor-pointer absolute pin-r pin-t m-4" src="@/assets/SVG/cross-partners.svg" alt="">
          <p class="font-bold text-center mt-8">
            Упс... Что-то пошло не так :(
          </p>
          <p class="mt-5 text-center mb-5">
            Ссылка больше не актуальна
          </p>
        </div>
        <div v-else-if="'players' in error" class="p-8 relative">
          <img @click="close" class="cursor-pointer absolute pin-r pin-t m-4" src="@/assets/SVG/cross-partners.svg" alt="">
          <p class="font-bold text-center mt-8">
            Упс... Что-то пошло не так :(
          </p>
          <p class="mt-5 text-center mb-5">
            В команде превышен лимит участников
          </p>
        </div>
        <div v-else class="p-8 relative">
            <img @click="close" class="cursor-pointer absolute pin-r pin-t m-4" src="@/assets/SVG/cross-partners.svg" alt="">
            <p class="font-bold text-center mt-8">
              Упс... Что-то пошло не так :(
            </p>
            <p class="mt-5 text-center mb-5">
              Вы уже являетесь участником команды <span class="text-brand-light" style="word-break: break-all"> {{team_name}} </span>
            </p>
        </div>

    </modal>
</template>

<script>
import Modal from '@/views/modals/base-modal';
import ModalMixin from '@/mixins/modals.js';

export default {
  name: 'ConfirmInviteModal',
  mixins: [ModalMixin],
  props: ['team_name', 'error'],
  components: { Modal },
  created() {
    if (this.error) {
      console.log(this.error);
      console.log(Object.values(this.error).length);
    }
  },
//   computed: {
//     isMobile() {
//       return window.innerWidth < 640;
//     },
//   },
};

</script>

<style scoped>

.cancel {
    border: 1px solid black
}

</style>
